export const handleResponse = (response: any) => {
    if ([401, 403].indexOf(response.response.status) !== -1) {
    // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
        localStorage.removeItem("token");
        localStorage.removeItem("token-login");
        window.location.reload();
    }
}
